import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser';
import React from 'react';
import { getLinkTargetByUrl } from '../../../../utils/getLinkTargetByUrl';
import { getLinkRelAttributeValue } from '../../../../utils/getLinkRelAttributeValue';

export const removeNonBreakingSpaces = (text: string) => text?.replace(/&nbsp;/g, ' ') || text;

export const parserOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    const { attribs, children, tagName } = domNode;
    if (tagName === 'a') {
      const { href } = attribs;
      return (
        <a href={href} className="article__link" target={getLinkTargetByUrl(href)} rel={getLinkRelAttributeValue(href)}>
          {domToReact(children, parserOptions)}
        </a>
      );
    }

    return domNode;
  },
};
export const parseWithoutNonBreakingSpaces = (text: string) => parse(removeNonBreakingSpaces(text), parserOptions);
